import { Component, input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PopoverDirective } from "@kno2/common/directives";

@Component({
    selector: "kno2-profile-user-preferences",
    imports: [FormsModule, ReactiveFormsModule, PopoverDirective],
    templateUrl: "./profile-user-preferences.component.html"
})
export class ProfileUserPreferencesComponent {
    public preferencesForm = input.required<FormGroup>();
    protected afterProcessMessageTooltip = `Select what action to take after marking a message in My Intake as <i>Processed</i>`;
}
